import PropTypes from "prop-types"
import React, { useState } from "react"

import Button from "src/components/Button"
import TextCollapsible from "src/components/TextCollapsible"
import Tooltip from "src/components/Tooltip"

import EditRequestDescriptionModal from "./EditRequestDescriptionModal"

const LOCK_TOOLTIP = "Reopen this work order to edit."

const RequestDescriptionSection = ({
  requestDescription,
  workOrderSequentialId,
  isClosed = false,
}) => {
  const [isEditModalOpen, setIsEditModalOpen] = useState(false)
  const hasDescription = Boolean(requestDescription?.trim())
  const actionLabel = hasDescription
    ? "Edit request description"
    : "Add request description"

  return (
    <div>
      <div className="mb-3 flex items-center justify-between gap-2">
        <h2 className="m-0 text-xs font-semibold uppercase tracking-wide text-gray-500">
          Request Description
        </h2>
        {isClosed ? (
          <Tooltip text={LOCK_TOOLTIP} variant="dark">
            <span
              aria-label="Request description locked"
              className="inline-flex h-7 w-7 items-center justify-center text-gray-500"
            >
              <i className="fa-solid fa-lock" aria-hidden="true" />
            </span>
          </Tooltip>
        ) : (
          <Button
            type="button"
            title={actionLabel}
            variant="ghost-tertiary"
            iconOnly
            small
            icon={`${
              hasDescription ? "fa-pen-to-square" : "fa-plus"
            } text-base`}
            iconStyle="solid"
            onClick={() => setIsEditModalOpen(true)}
          />
        )}
      </div>
      {hasDescription ? (
        <TextCollapsible lines={3}>
          <span>{requestDescription}</span>
        </TextCollapsible>
      ) : (
        <span className="text-sm italic text-gray-500">
          No request description
        </span>
      )}
      {!isClosed && (
        <EditRequestDescriptionModal
          isOpen={isEditModalOpen}
          onClose={() => setIsEditModalOpen(false)}
          requestDescription={requestDescription}
          workOrderSequentialId={workOrderSequentialId}
        />
      )}
    </div>
  )
}

RequestDescriptionSection.propTypes = {
  requestDescription: PropTypes.string,
  workOrderSequentialId: PropTypes.string.isRequired,
  isClosed: PropTypes.bool,
}

export default RequestDescriptionSection
